var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopOnlinePlatforms = function SvgTopOnlinePlatforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.946 45.891c11.992 0 21.764-9.627 21.943-21.618.179-11.99-9.301-21.905-21.288-22.263-11.987-.358-22.042 8.973-22.579 20.954-.536 11.98 8.644 22.173 20.615 22.888",
    stroke: "#EAEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.045 37.945A21.946 21.946 0 1 0 39.945 2",
    stroke: "#37A3BC"
  }))));
};
export default SvgTopOnlinePlatforms;